import React from "react";
import styled from "styled-components";
import Header from "./components/Header";
import Icon from "./icons/Icon1";
import Icon2 from "./icons/Icon2";
import Icon3 from "./icons/Icon3";
import Icon4 from "./icons/Icon4";
import Icon5 from "./icons/Icon5";
import Icon6 from "./icons/Icon6";
import Icon7 from "./icons/Icon7";
import Icon8 from "./icons/Icon8";
import useScreenSize from "../../utils/useScreenSize";

const Wrapper = styled.div`
   z-index: 2;
   display: flex;
   align-items: center;
   flex-direction: column;
   background: #CB1700;
`
const HeaderWrapper = styled.div`
   display: flex;
   padding: 0;
   margin: 0;
   justify-content: center;
   align-items: flex-end;
   width: 100%;
   padding-bottom: 50px;
   svg{
      width: 70vw;
   }
   @media only screen and (max-width: 600px) {
      .what-need-to-do{
          width: 90vw;
       }
    
      }
   
`

const ContentWrapper = styled.div`
   display: flex;
 
   padding: 0;
   margin: 0;
   justify-content: center;
   align-items: flex-end;
   width: 100%;
   svg{
      width: 70vw
   }
`


const ContentSpan = styled.div`
  background: #CB1700;
  width: 15vw;
  //height: 500px;
`
const IconsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  background: #CB1700;
  width: 70vw;
`
const ImageWrapper = styled.div`
  display: flex;
  min-height: 80px;
  align-items: flex-end;
  justify-content: center;
`
const IconWrapper = styled.div`
display: flex;
flex-direction: column;
font-size: 1.2em;
text-align: center;
align-items: center;
width: 33%;
color: white;

@media only screen and (max-width: 900px) {
      width: 50%;
  }
  
@media only screen and (max-width: 600px) {
      width: 100%;
  }  
svg{
  width: 25%;
  padding-bottom: 20px;
}
p{
  padding: 0 20px;
}
padding-bottom: 20px;

`

const IconBlock = ({icon, children}) => {
    return (
        <IconWrapper>
            <ImageWrapper>
                {icon}
            </ImageWrapper>
            <p>{children}</p>
        </IconWrapper>
    )
}

const WhatBlock = ({}) => {
    const {width} = useScreenSize();
    const isMobile = width <= 600;
    return (
        <Wrapper>
            <HeaderWrapper>
                <Header width={'100%'} />
            </HeaderWrapper>
            <ContentWrapper>
                <ContentSpan/>
                <IconsWrapper>
                    <IconBlock icon={<Icon/>}>
                        На заводах, стройках, частных
                        фабриках, в больших и малых компаниях, на предприятиях будет проводиться только одна самая важная
                        работа – требование справедливости.
                    </IconBlock>
                    <IconBlock icon={<Icon2/>}>
                        Сотрудники МВД и других силовых структур проигнорируют преступные приказы.
                    </IconBlock>

                    <IconBlock icon={<Icon3/>}>
                        В автопарках и транспортных компаниях найдутся тысячи причин не выходить на рейс: автобусы, трамваи, поезда и троллейбусы, метро и такси – всё это очень важно, но возвращение законности и гражданских свобод важнее.
                    </IconBlock>
                    <IconBlock icon={<Icon4/>}>
                        Инженеры и программисты будут решать только самую сложную задачу – консолидация для защиты друг друга и выполнения народных требований.
                    </IconBlock>
                    <IconBlock icon={<Icon5/>}>
                        Управленцы и собственники компаний согласуют сотни отгулов.
                    </IconBlock>
                    <IconBlock icon={<Icon6/>}>
                        Супермаркеты и торговые центры, парикмахерские и тренажерные залы будут выглядеть так, будто начался карантин.
                    </IconBlock>
                    <IconBlock icon={<Icon7/>}>
                        В университеты и школу придут студенты и ученики. Но не на занятия, а за справедливостью. А преподаватели их поддержат.
                    </IconBlock>
                    <IconBlock icon={<Icon8/>}>
                        Все специалисты не будут выполнять свои обязанности, поскольку бывший президент не выполняет свои.
                    </IconBlock>
                </IconsWrapper>
                <ContentSpan/>
            </ContentWrapper>
        </Wrapper>

    )
}

export default WhatBlock;
